import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (
      <div className="py-6 container">
        <form>
          <div className="ant-card ant-card-bordered">
            <div className="ant-card-body">
              <p className="has-text-primary is-size-7">(*) is required field.</p>
              <div className="field">
                <div className="is-flex is-align-items-center mb-2 flex-wrap">
                  <div className="is-flex-grow-1 mr-4"><label className="label" for="tokenAddress">Token address<sup
                    className="has-text-danger">*</sup></label></div>
                  <div className="mt-2"><button type="button" className="ant-btn ant-btn-default"><span>Create token</span></button>
                  </div>
                </div>
                <div className="control"><input type="text" placeholder="Ex: PinkMoon" id="tokenAddress" name="tokenAddress" className="input" autocomplete="off" value="" />
                  <div className="help is-info s-size-8">Choose a token to integrate with Pink Anti-Bot. <br /> Check out the guide how to integrate Pink Anti-Bot for custom contract here: <a href="https://github.com/pinkmoonfinance/pink-antibot-guide" target="_blank"
                    rel="noreferrer">https://github.com/pinkmoonfinance/pink-antibot-guide</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
